{
  "common": {
    "loading": "Loading...",
    "not_found": "Not found",
    "back": "← Back",
    "add_to_cart": "Add to cart",
    "added": "Added ✓",
    "remove": "Remove",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "search": "Search",
    "clear": "Clear",
    "error": "Error",
    "yes": "Yes",
    "no": "No"
  },
  "nav": {
    "home": "Home",
    "favorites": "Favorites",
    "cart": "Cart",
    "profile": "Profile"
  },
  "cart": {
    "title": "Cart",
    "empty": "Cart is empty.",
    "empty_hint": "Add items from the catalog",
    "go_to_catalog": "Go to catalog",
    "size_word": "size",
    "increase": "Increase",
    "decrease": "Decrease"
  },
  "favorites": {
    "title": "Favorites",
    "empty": "Nothing here yet.",
    "empty_hint": "Add items to come back later",
    "go_to_catalog": "Go to catalog",
    "recommendations": "You may also like",
    "aria_add": "Add to favorites",
    "aria_remove": "Remove from favorites"
  },
  "product": {
    "not_found": "Product not found",
    "article": "Article",
    "country": "Country",
    "composition": "Composition",
    "color": "Color",
    "size": "Size",
    "stock": "In stock: {count} pcs.",
    "description": "Description",
    "view_image": "Photo {n}",
    "delivery_estimate": "Delivery 7–14 days"
  },
  "badges": {
    "original": "Original",
    "in-stock": "In stock",
    "new": "New",
    "hit": "Hit",
    "sale": "Sale",
    "exclusive": "Exclusive"
  },
  "catalog": {
    "search_placeholder": "Search the catalog",
    "all": "All",
    "category": "Category",
    "brand": "Brand",
    "color": "Color",
    "size": "Size",
    "sort": "Sort",
    "sort_newest": "Newest first",
    "sort_price_asc": "Cheapest first",
    "sort_price_desc": "Most expensive first",
    "all_categories": "All categories",
    "all_brands": "All brands",
    "all_colors": "All colors",
    "all_sizes": "All sizes",
    "empty": "Nothing found",
    "error": "Failed to load catalog",
    "count": "{count} items",
    "all_products": "All products",
    "in_stock": "In stock",
    "foreign": "Original",
    "filter": "Filter",
    "reset_filters": "Reset filters"
  },
  "admin": {
    "title": "Admin panel",
    "no_access": "No access",
    "add": "Add",
    "edit": "Edit",
    "save": "Save",
    "delete": "Delete",
    "ban": "Ban",
    "unban": "Unban",
    "saved": "Saved",
    "deleted": "Deleted",
    "empty": "Empty",
    "on": "On",
    "off": "Off",
    "f_title": "Title",
    "f_subtitle": "Subtitle",
    "f_image": "Image URL",
    "f_position": "Position",
    "f_active": "Active",
    "f_name": "Name",
    "f_address": "Address",
    "f_city": "City",
    "f_phone": "Phone",
    "f_lat": "Latitude",
    "f_lng": "Longitude",
    "f_slug": "Slug",
    "f_main": "Main",
    "f_sort": "Sort",
    "f_kind": "Kind",
    "dict_size": "Sizes",
    "dict_color": "Colors",
    "dict_brand": "Brands",
    "dict_badge": "Badges",
    "f_hex": "Color (hex)",
    "f_article": "Article",
    "f_price": "Price",
    "f_oldprice": "Old price",
    "f_badge": "Badge",
    "f_status": "Status",
    "a_orders": "Orders",
    "a_revenue": "Revenue",
    "a_users": "Users",
    "a_products": "Products",
    "a_visits": "Visits",
    "a_by_status": "By status",
    "sec_orders": "Orders",
    "sec_catalog": "Catalog",
    "sec_marketing": "Marketing",
    "sec_system": "System",
    "mod_orders": "Orders",
    "mod_orders_hint": "All orders and status changes",
    "mod_returns": "Returns",
    "mod_returns_hint": "Product return requests",
    "mod_promotions": "Promotions",
    "mod_promotions_hint": "Discounts and bonuses",
    "mod_campaigns": "Broadcasts",
    "mod_campaigns_hint": "News and promos to clients",
    "camp_new": "+ New broadcast",
    "camp_empty": "No broadcasts yet",
    "camp_f_title": "Title (internal)",
    "camp_f_body": "Message text",
    "camp_f_image": "Image (URL, optional)",
    "camp_f_target": "Button link",
    "camp_f_pick": "Link to",
    "camp_f_button": "Button text",
    "camp_btn_ph": "Open",
    "camp_f_audience": "Audience",
    "camp_target_none": "No button",
    "camp_target_product": "To product",
    "camp_target_category": "To category",
    "camp_aud_all": "All",
    "camp_send": "📣 Send broadcast",
    "camp_sending": "Sending…",
    "camp_sent": "Sent: {{sent}}, failed: {{failed}}",
    "camp_stats": "Sent: {{sent}} · failed: {{failed}}",
    "camp_save_first": "Save first, then the send button appears",
    "camp_status_draft": "Draft",
    "camp_status_sending": "Sending",
    "camp_status_done": "Sent",
    "cancel": "Cancel",
    "promo_new": "+ New promotion",
    "promo_empty": "No promotions yet",
    "promo_inactive": "Off",
    "promo_pick_product": "Select product",
    "promo_type_cart_total": "Cart total discount",
    "promo_type_day": "Weekday discount",
    "promo_type_product_buy": "Buy-product discount",
    "promo_type_bonus_item": "Bonus item",
    "promo_reward_percent": "Percent %",
    "promo_reward_fixed": "Amount",
    "promo_f_title": "Title",
    "promo_f_code": "Promo code (empty = auto)",
    "promo_code_ph": "e.g. SALE10 (empty — applies to all)",
    "promo_f_type": "Promotion type",
    "promo_f_min_total": "Cart total from",
    "promo_f_min_total_opt": "Min. total (optional)",
    "promo_f_weekdays": "Weekdays",
    "promo_f_trigger_product": "Trigger product",
    "promo_f_min_qty": "Min. quantity",
    "promo_f_reward_kind": "Discount",
    "promo_f_reward_value": "Value",
    "promo_f_bonus_product": "Bonus product",
    "promo_f_bonus_name": "Bonus name",
    "promo_f_bonus_qty": "Bonus qty",
    "promo_f_starts": "Starts",
    "promo_f_ends": "Ends",
    "promo_f_priority": "Priority",
    "promo_f_active": "Active",
    "promo_f_stackable": "Stackable",
    "wd_0": "Sun",
    "wd_1": "Mon",
    "wd_2": "Tue",
    "wd_3": "Wed",
    "wd_4": "Thu",
    "wd_5": "Fri",
    "wd_6": "Sat",
    "returns_empty": "No return requests",
    "mod_banners": "Banners",
    "mod_banners_hint": "Promo banners on home",
    "mod_pickup": "Pickup points",
    "mod_pickup_hint": "Self-pickup locations",
    "mod_categories": "Categories",
    "mod_categories_hint": "Catalog categories",
    "mod_dictionary": "Dictionaries",
    "mod_dictionary_hint": "Sizes, colors, brands, badges",
    "mod_products": "Products",
    "mod_products_hint": "Products and prices",
    "mod_settings": "Settings",
    "mod_settings_hint": "Contacts, delivery, legal",
    "mod_users": "Users",
    "mod_users_hint": "Roles and ban",
    "mod_analytics": "Analytics",
    "mod_analytics_hint": "Orders, revenue, visits",
    "no_orders": "No orders yet",
    "customer": "Customer",
    "change_status": "Status",
    "status_updated": "Status updated",
    "courier": "Courier",
    "courier_none": "No courier",
    "courier_assigned": "Courier assigned",
    "car_model": "Model",
    "car_color": "Color",
    "car_plate": "Plate",
    "fulfill_title": "Delivery check-off",
    "fulfill": "Confirm delivery",
    "fulfilling": "Saving…",
    "fulfill_hint": "Enter the actually delivered quantity. Undelivered items return to stock and the total is recalculated.",
    "fulfill_locked": "Available only for Packed / Delivering statuses.",
    "ordered_q": "ordered",
    "mark_delivery": "Mark delivery",
    "photos": "Photos",
    "photos_title": "Product photos",
    "photos_upload": "+ Upload photo",
    "photos_uploading": "Uploading…",
    "photos_empty": "No photos yet",
    "photos_main": "Main",
    "photos_set_main": "Set as main"
  },
  "checkout": {
    "items": "Items ({count})",
    "delivery": "Delivery",
    "free": "free",
    "discount": "Discount",
    "bonus": "Gift",
    "promo_placeholder": "Promo code",
    "promo_applied": "applied",
    "total": "Total",
    "clear": "Clear",
    "page_title": "Checkout",
    "section_contact": "Contact details",
    "section_delivery": "Delivery method",
    "section_payment": "Payment",
    "section_notes": "Order notes",
    "name_label": "Recipient name",
    "phone_label": "Phone",
    "phone_share_cta": "Share phone number",
    "phone_unavailable": "This feature is only available inside Telegram",
    "address_label": "Street, building, apartment",
    "address_placeholder": "1 Example St., apt. 25",
    "city_label": "City",
    "city_placeholder": "Tashkent",
    "postal_label": "Postal code",
    "postal_placeholder": "100000",
    "pickup_select": "Select a pickup point",
    "pickup_empty": "No pickup points available",
    "pickup_main_badge": "Main",
    "notes_placeholder": "Order notes (optional)",
    "place_order": "Place order",
    "placing": "Placing...",
    "order_created": "Order placed",
    "back_to_cart": "← Back to cart",
    "continue_to_checkout": "Checkout",
    "empty_cart": "Cart is empty",
    "err_required_name": "Please enter the recipient name",
    "err_required_phone": "Please provide a phone number",
    "err_required_pickup": "Please select a pickup point",
    "err_required_address": "Please enter a delivery address",
    "err_required_city": "Please enter a city",
    "order_summary": "Your order",
    "section_date": "Delivery date",
    "date_today": "Today",
    "date_change": "Change",
    "recipient_me": "I'm the recipient",
    "recipient_other": "Order for someone else",
    "section_recipient": "Recipient details",
    "recipient_fio_label": "Recipient full name",
    "recipient_fio_placeholder": "John Doe",
    "recipient_phone_label": "Recipient phone",
    "share_location_cta": "Share location",
    "location_hint": "You can change the address after filling it in",
    "address_map_hint": "Drop a pin on the map or type the address. Intercom/landmark — in order notes.",
    "location_unavailable": "This feature is only available inside Telegram",
    "payer_me": "I'll pay",
    "payer_recipient": "Recipient pays",
    "payer_hint": "Payment method — cash on delivery",
    "date_tomorrow": "Tomorrow"
  },
  "profile": {
    "title": "Profile",
    "default_name": "User",
    "telegram_id": "Telegram ID",
    "language": "Language",
    "premium": "Premium",
    "platform": "Platform",
    "sdk_version": "SDK version",
    "edit_name": "Edit name",
    "first_name": "First name",
    "last_name": "Last name",
    "save": "Save",
    "saved": "Saved",
    "share_phone": "Share phone number",
    "phone_set": "Phone saved",
    "phone_empty": "Not set",
    "phone_unavailable": "This feature is only available inside Telegram",
    "share_location": "Share location",
    "location_set": "Location saved",
    "location_empty": "Not set",
    "location_unavailable": "This feature is only available inside Telegram",
    "tg_source_note": "Avatar and name are pulled from your Telegram account. You can override them here.",
    "photo_bad_type": "Please choose an image (JPEG, PNG or WebP)",
    "photo_too_large": "File is too large — max 5 MB",
    "photo_uploaded": "Photo uploaded successfully",
    "photo_upload_error": "Failed to upload photo",
    "about_store": "About the store",
    "about_store_hint": "Address, contacts and legal info",
    "menu_orders": "My orders",
    "menu_orders_hint": "Order history and statuses",
    "menu_addresses": "My addresses",
    "menu_addresses_hint": "Delivery address on the map",
    "menu_favorites": "Favorites",
    "menu_favorites_hint": "Saved items",
    "menu_cart": "Cart",
    "menu_cart_hint": "Items to checkout",
    "menu_delivery": "Delivery & payment",
    "menu_delivery_hint": "Delivery terms and payment methods",
    "menu_return": "Returns & exchanges",
    "menu_return_hint": "Return and exchange policy",
    "menu_support": "Support",
    "menu_support_hint": "Contact us about your order",
    "menu_channel": "Our channel",
    "menu_channel_hint": "News, arrivals and updates"
  },
  "contacts": {
    "title": "About the store",
    "store_name": "Store",
    "address": "Address",
    "open_in_maps": "Open in maps",
    "copy_address": "Copy address",
    "copied": "✓ Copied",
    "copy_failed": "Could not copy",
    "support": "Support",
    "phone": "Phone",
    "email": "Email",
    "telegram": "Telegram",
    "legal": "Legal info",
    "legal_name": "Legal name",
    "legal_inn": "Tax ID (INN)",
    "legal_address": "Legal address"
  },
  "splash": {
    "brand": "EUROSTYLE"
  },
  "pickup_code": {
    "show_to_courier": "Show to the courier at the pickup point",
    "code_label": "Order code",
    "qr_alt": "Order QR code",
    "scan_hint": "The courier scans the QR or types the code — the order is then marked as delivered.",
    "invalid": "Invalid code"
  },
  "addresses": {
    "title": "My addresses",
    "delivery_address": "Delivery address",
    "placeholder": "City, street, building",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Address saved",
    "hint": "Drop a pin on the map or type the address. Intercom/landmark — in order notes."
  },
  "orders": {
    "title": "My orders",
    "empty": "No orders yet",
    "empty_hint": "Place your first order from the catalog"
  },
  "order": {
    "title": "Order #{short_id}",
    "not_found": "Order not found",
    "status_new": "New",
    "status_packed": "Packed",
    "status_delivering": "Delivering",
    "status_delivered": "Delivered",
    "status_partial": "Partially delivered",
    "status_cancelled": "Cancelled",
    "delivery_pickup": "Pickup",
    "delivery_courier": "Courier",
    "address": "Delivery address",
    "pickup_point": "Pickup point",
    "courier": "Courier",
    "open_in_maps": "Open in maps",
    "call_phone": "Call",
    "items_count": "{count, plural, one {# item} other {# items}}",
    "subtotal": "Items",
    "shipping": "Shipping",
    "total": "Total",
    "ordered_at": "Placed on {date}",
    "verified_at": "Received on {date}",
    "delivery_code_hint": "Show the code to the courier"
  },
  "courier": {
    "title": "My deliveries",
    "profile_hint": "Assigned orders and confirmation",
    "code_label": "Customer's pickup code",
    "code_placeholder": "XXXXXXXX",
    "confirm": "Confirm delivery",
    "confirming": "Confirming…",
    "confirmed": "Delivery confirmed ✓",
    "empty": "No assigned deliveries",
    "call": "Call",
    "maps": "On map"
  },
  "returns": {
    "request": "Request a return",
    "requested_ok": "Return request sent",
    "reason_placeholder": "Reason for return (optional)",
    "ordered": "ordered: {count}",
    "submit": "Submit request",
    "sending": "Sending…",
    "reason": "Reason",
    "approve": "Approve",
    "reject": "Reject",
    "mark_received": "Mark received (restock)",
    "status_requested": "Requested",
    "status_approved": "Approved",
    "status_received": "Received",
    "status_rejected": "Rejected"
  },
  "errors": {
    "network": "No connection. Check your internet.",
    "internal": "Something went wrong. Please try again.",
    "db": "Database error.",
    "validation": "Invalid data.",
    "forbidden": "Access denied.",
    "not_found": "Not found.",
    "banned": "Account is blocked.",
    "no_user": "User not found.",
    "init_data_invalid": "Telegram authorization failed.",
    "init_data_missing": "Open the app from Telegram.",
    "invalid_state": "Invalid order status.",
    "storage": "File upload error.",
    "invalid_file_type": "Unsupported file format.",
    "invalid_file_size": "File is too large.",
    "invalid_phone": "Invalid phone number.",
    "stock": "Not enough stock."
  }
}
